/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChipDto } from '../../models/chip-dto';

export interface GetAllChips$Plain$Params {
}

export function getAllChips$Plain(http: HttpClient, rootUrl: string, params?: GetAllChips$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ChipDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllChips$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ChipDto>>;
    })
  );
}

getAllChips$Plain.PATH = '/v1/chips/all';
